/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum NotificationBarsIds {
    PatchingVbr = 'PatchingVbr',
    SupportCaseAttachments = 'SupportCaseAttachments',
}